import { Pages } from "../../../utils";
import { ActionButton } from "../components/Button";
import { Badge } from "../components/Badge";
import { IconArrowRight } from "../components/Icons";
import { personalityQuiz } from "../data";
import personalityCardLeft from "../../../assets/home-page/matching/left.png";
import personalityCardCenter from "../../../assets/home-page/matching/center.png";
import personalityCardRight from "../../../assets/home-page/matching/right.png";

export const PersonalitySection = () => (
  <section className="sg-section sg-personality">
    <div className="sg-container">
      <div className="sg-personality__content">
        <Badge variant="light" className="sg-personality__badge">
          {personalityQuiz.label}
        </Badge>
        <h2 className="sg-section__title sg-section__title--light">
          {personalityQuiz.title}
        </h2>
        <p className="sg-section__subtitle sg-section__subtitle--light">
          {personalityQuiz.subtitle}
        </p>

        <div className="sg-personality__cards">
          <img
            className="sg-personality__card-image sg-personality__card-image--side"
            src={personalityCardLeft}
            alt="Personality quiz card preview"
          />
          <img
            className="sg-personality__card-image sg-personality__card-image--center"
            src={personalityCardCenter}
            alt="Personality quiz card preview"
          />
          <img
            className="sg-personality__card-image sg-personality__card-image--side"
            src={personalityCardRight}
            alt="Personality quiz card preview"
          />
        </div>

        <div className="sg-personality__cta">
          <div className="sg-personality__cta-text">{personalityQuiz.cta}</div>
          <div className="sg-personality__cta-actions">
            <ActionButton
              variant="light"
              size="md"
              to={Pages.HOMEOWNER_PERSONALITY_QUIZ}
            >
              For Homeowners <IconArrowRight size={16} />
            </ActionButton>
            <ActionButton
              variant="light"
              size="md"
              to={Pages.DESIGNER_PERSONALITY_QUIZ}
            >
              For Interior Designers <IconArrowRight size={16} />
            </ActionButton>
          </div>
        </div>
      </div>
    </div>
  </section>
);
